import { ProjectMenuButton } from '@components/App/ProjectMenuButton'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { ProjectAvatarActions } from '@store/projectAvatar'
import { StatusActions } from '@store/reducers/dashboard/statuses'
import type { AppState } from '@store/types'
import type React from 'react'
import { type ChangeEvent, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { MenuContent, ProjectAvatar } from './components'
import { useProjectMenu } from './hooks'

export const ProjectMenu: React.FC = () => {
  const ref = useRef<HTMLInputElement>(null)
  const dispatch = useDispatch()
  const { onClick, avatar, hideMenu } = useProjectMenu(ref)

  const meta = useSelector((state: AppState) => state.manager.meta)
  const onOpen = () => {
    if (
      meta.id &&
      !meta.template &&
      meta.access.canEdit &&
      meta.space.features.includes('status')
    ) {
      dispatch(
        StatusActions.request({
          projectId: meta.id,
          operation: { type: 'load' },
        })
      )
    }
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(ProjectAvatarActions.upload(e.target.files))
  }

  if (hideMenu) {
    return <ProjectAvatar avatar={avatar} />
  }

  return (
    <>
      <input
        ref={ref}
        onChange={onChange}
        type="file"
        hidden
        accept=".png, .jpg, .jpeg"
      />
      <DropdownMenu.Root align="start" onClick={onClick} content={MenuContent}>
        <ProjectMenuButton avatar={avatar} onOpen={onOpen} />
      </DropdownMenu.Root>
    </>
  )
}
